import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { NbTabComponent, NbTabsetComponent } from '@nebular/theme';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs';
import { AnalyticsService } from '../../@core/utils';
import { StudentAssignmentStatus } from '../../enum/assignment';
import { ClearObservableHelper } from '../../helpers/ClearObservableHelper';
import { Assignment } from '../../interface/assignment';
import { Classroom } from '../../interface/calendar';
import { User } from '../../interface/user';
import { AssignmentQuestionService } from '../../services/assignment-question.service';
import { AssignmentsService } from '../../services/assignments.service';
import { PacingPlanService } from '../../services/pacing-plan.service';
import { StorageService } from '../../services/storage.service';
import { StudentService } from '../../services/student.service';
declare var bootstrap: any;

@Component({
  selector: 'ngx-students-upcoming-assignments',
  templateUrl: './students-upcoming-assignments.component.html',
  styleUrls: ['./students-upcoming-assignments.component.scss'],
})
export class StudentsUpcomingAssignmentsComponent extends ClearObservableHelper implements OnInit, AfterViewInit {
  student;
  studentUpcomingAssignments = [];
  studentSubmittedAssignments = [];
  currentPage = 1;
  totalPages = 1;
  loading = false;
  @Input() isExpand = false;
  @Input() classroom: Classroom;
  @Input() currentUser: User;
  public modalRef;
  currentAssignmentEvaluation;
  currentStatus = '';
  currentEvaluationToStore;
  @ViewChild('myModal') myModal;
  public isMobileScreen = window.innerWidth <= 550;
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.isMobileScreen = event.target.innerWidth <= 550;
  }
  selectedTab = StudentAssignmentStatus.UPCOMING;
  @Input() activeTab;
  @ViewChild('viewAssignmentEvaluationModal', { static: false })
  modalElement!: ElementRef;
  modalInstance: any;
  @ViewChild('tabset') tabsetEl: NbTabsetComponent;
  @ViewChild('upcoming') upcomingTabElement: NbTabComponent;
  @ViewChild('submitted') submittedTabElement: NbTabComponent;
  @ViewChild('missed') missedTabElement: NbTabComponent;
  setActiveAdd: boolean = false;
  @Output() changeTab = new EventEmitter<boolean>();
  assignmentQuestions: Assignment[] = [];
  feedback = '';

  constructor(
    private studentService: StudentService,
    private assignmentService: AssignmentsService,
    private storageService: StorageService,
    public router: Router,
    public modalService: NgbModal,
    public alayticsService: AnalyticsService,
    private pacingPlanService: PacingPlanService,
    private spinner: NgxSpinnerService,
    private questionService: AssignmentQuestionService,
  ) {
    super();
  }

  async ngOnInit() {
    try {
      this.loading = true;
      // Commented out to avoid double API calls, as it causes the loader to appear twice.
      // if (this.classroom) {
      //   await this.getRecordsAsPerSelectedTab();
      // }

      this.studentService.currentClassroom.subscribe(async (x: Classroom) => {
        if (x) {
          this.loading = true;
          this.classroom = x;
          await this.getRecordsAsPerSelectedTab();
          this.loading = false;
        }
      });

      this.pacingPlanService.studentCurrentSubject.subscribe(async (x) => {
        this.loading = true;
        this.classroom['current_subject_id'] = x;
        await this.getRecordsAsPerSelectedTab();
        this.loading = false;
      });
      this.loading = false;
      // to jump to selected tab
      setTimeout(() => {
        if (this.activeTab && this.isExpand) {
          this.selectCurrentTabValue();
        }
      }, 500);
      this.handleCalendarChangeData();
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  selectCurrentTabValue() {
    try {
      if (this.tabsetEl) {
        let selectedTab;
        switch (this.activeTab.toLowerCase()) {
          case StudentAssignmentStatus.UPCOMING:
            selectedTab = this.upcomingTabElement;
            break;
          case StudentAssignmentStatus.SUBMITTED:
            selectedTab = this.submittedTabElement;
            break;
          case StudentAssignmentStatus.MISSED:
            selectedTab = this.missedTabElement;
            break;
          default:
            selectedTab = this.upcomingTabElement;
        }
        this.tabsetEl.selectTab(selectedTab);
      }
    } catch (err) {
      console.log(
        '🚀 ~ students-upcoming-assignments.component.ts:116 ~ StudentsUpcomingAssignmentsComponent ~ selectCurrentTabValue ~ err:',
      );
    }
  }

  ngAfterViewInit(): void {
    try {
      if (this.modalElement) {
        this.modalInstance = new bootstrap.Modal(this.modalElement.nativeElement, {
          backdrop: 'static',
          keyboard: false,
          focus: true,
        });
      }
    } catch (error) {}
  }

  async getAssignments() {
    try {
      this.loading = true;
      this.spinner.show();
      await this.getRecordsAsPerSelectedTab();
      this.spinner.hide();

      this.loading = false;
    } catch (error) {
      this.spinner.hide();
      this.loading = false;
      // console.log(error)
    }
  }

  /**
   * Fetches upcoming assignments for the student based on the classroom and user ID.
   */
  async getStudentUpcomingAssignments() {
    try {
      this.spinner.show();
      const user = this.storageService.getItem('user');
      const upcomingAssignments: any = await this.assignmentService.AssignmentsByUserIdAndTime({
        classroom_id: this.classroom.id,
        page: this.isExpand ? null : this.currentPage,
        isExpand: true,
        subject_id: this.classroom?.current_subject_id,
        user_id: this.currentUser ? this.currentUser?.id : user?.user?.id,
      });
      if (upcomingAssignments && upcomingAssignments.length > 0) {
        if (!this.isExpand) {
          const perPage = 2;
          const start = (this.currentPage - 1) * perPage;
          const paginatedAssignments = upcomingAssignments.slice(start, start + perPage);
          this.totalPages = Math.ceil(upcomingAssignments.length / perPage);
          this.studentUpcomingAssignments = await this.updateAssignmentStatus(paginatedAssignments);
        } else {
          this.studentUpcomingAssignments = await this.updateAssignmentStatus(upcomingAssignments);
        }
      } else {
        this.studentUpcomingAssignments = [];
        this.totalPages = 1;
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error('Error in getStudentUpcomingAssignments', error);
    }
  }

  async updateAssignmentStatus(assignmentData) {
    try {
      return assignmentData.map((assignment) => {
        const assignmentStatus = assignment.studentAssignmentStatus;
        if (assignmentStatus && assignmentStatus.length > 0) {
          assignment.status = assignmentStatus[assignmentStatus.length - 1].completed ? 'Completed' : 'Pending';
        } else {
          if (this.selectedTab === StudentAssignmentStatus.MISSED) {
            assignment.status = 'Missed';
          } else {
            assignment.status = 'Pending';
          }
        }
        return assignment;
      });
    } catch (error) {}
  }

  closeDialog() {
    this.studentService.isExpand.emit({
      isExpand: false,
      compontentLabel: 'assignments',
    });
  }

  takeAssignment(assignmentId: number) {
    try {
      if (this.isExpand) {
        this.studentService.isExpand.emit({
          isExpand: false,
          compontentLabel: 'assignments',
        });
        this.studentService.removeStudentObservers();
      }

      this.router.navigate([
        '/student-assignments/take-assignment',
        assignmentId,
        this.classroom.id,
        this.classroom?.current_subject_id,
        this.isExpand,
      ]);
    } catch (error) {
      // console.log(error);
    }
  }

  async viewAssignmentEvaluation(evaluationData, assignment: any, assignmentStatus: string): Promise<void> {
    try {
      this.currentAssignmentEvaluation = evaluationData;
      this.currentEvaluationToStore = evaluationData;
      // get the assignment questions if the assignment is missed
      if (assignmentStatus.toLowerCase() === StudentAssignmentStatus.MISSED) {
        this.spinner.show();
        this.assignmentQuestions = await this.questionService.assignmentQuestionsByAssignmentId({
          assignment_id: assignment.id || 0,
        });
        this.spinner.hide();
      }
      this.modalInstance.show();

      // this.modalRef = this.modalService.open(this.myModal, {
      //   size: 'lg',
      //   modalDialogClass: 'mymodal',
      //   centered: true,
      //   backdrop: 'static',
      //   animation: true,
      //   keyboard: false,
      //   backdropClass: 'modal-backdrop',
      //   windowClass: 'custom-overlay-container',
      // });
    } catch (error) {
      // console.log(error)
    }
  }

  filterStudentAnswer(value: string) {
    try {
      if (value === 'correct') {
        this.currentAssignmentEvaluation = this.currentEvaluationToStore.filter((x) => x.correctness === true);
      } else if (value === 'incorrect') {
        this.currentAssignmentEvaluation = this.currentEvaluationToStore.filter((x) => x.correctness === false);
      } else {
        this.currentAssignmentEvaluation = this.currentEvaluationToStore;
      }
    } catch (error) {
      // console.log(error);
    }
  }

  closeModal(): void {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }

  async onTabChange(event: any) {
    try {
      this.spinner.show();
      this.selectedTab = event.tabTitle.toLowerCase();
      this.changeTab.emit(event.tabTitle);
      this.currentPage = 1;
      this.totalPages = 1;

      if (this.selectedTab === StudentAssignmentStatus.SUBMITTED) {
        this.studentUpcomingAssignments = [];
        await this.getStudentPreviousAssignments();
      } else if (this.selectedTab === StudentAssignmentStatus.UPCOMING) {
        this.studentSubmittedAssignments = [];
        await this.getStudentUpcomingAssignments();
      } else {
        this.studentUpcomingAssignments = [];
        await this.getStudentPreviousAssignments();
      }
      this.spinner.hide();
    } catch (err) {
      this.spinner.hide();
    }
  }

  async getStudentPreviousAssignments() {
    try {
      this.spinner.show();
      const user = this.storageService.getItem('user');

      const response: any = await this.assignmentService.previousAssignmentsByUserIdAndTime({
        classroom_id: this.classroom.id,
        page: 0,
        isExpand: this.selectedTab === StudentAssignmentStatus.SUBMITTED ? true : false,
        subject_id: this.classroom?.current_subject_id,
        user_id: this.currentUser ? this.currentUser?.id : user?.user?.id,
      });
      // Get all assignments
      const allAssignments = response.items || response;
      if (!this.isExpand) {
        let sortedAssignments;
        if (this.selectedTab === StudentAssignmentStatus.SUBMITTED) {
          sortedAssignments = allAssignments.sort((a, b) => {
            const aCompleted = a.studentAssignmentStatus?.completed === true;
            const bCompleted = b.studentAssignmentStatus?.completed === true;
            return aCompleted === bCompleted ? 0 : aCompleted ? -1 : 1;
          });
        } else {
          sortedAssignments = allAssignments.filter((a) => {
            return a.studentAssignmentStatus.length === 0;
          });
        }
        // Show 2 records per page
        const perPage = 2;
        const start = (this.currentPage - 1) * perPage;
        const paginatedAssignments = sortedAssignments.slice(start, start + perPage);
        this.totalPages = Math.ceil(sortedAssignments.length / perPage);
        this.studentSubmittedAssignments = await this.updateAssignmentStatus(paginatedAssignments);
      } else {
        if (this.selectedTab === StudentAssignmentStatus.SUBMITTED) {
          this.studentSubmittedAssignments = await this.updateAssignmentStatus(allAssignments);
        } else {
          this.studentSubmittedAssignments = allAssignments.filter((a) => {
            return a.studentAssignmentStatus.length === 0;
          });
          this.studentSubmittedAssignments = await this.updateAssignmentStatus(this.studentSubmittedAssignments);
        }
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error('Error loading previous assignments:', error);
    }
  }

  async getRecordsAsPerSelectedTab() {
    this.spinner.show();
    if (this.selectedTab === StudentAssignmentStatus.UPCOMING) {
      await this.getStudentUpcomingAssignments();
    } else if (this.selectedTab === StudentAssignmentStatus.SUBMITTED) {
      await this.getStudentPreviousAssignments();
    } else {
      await this.getStudentPreviousAssignments();
    }
    this.spinner.hide();
  }

  /**
   * Opens a modal to display feedback for the assessment.
   * It formats the feedback with bullet points and displays it in a modal.
   * @param feedback The feedback text to be displayed in the modal.
   */
  async openFeedbackModal(event: MouseEvent, feedback) {
    try {
      event.stopPropagation();
      this.feedback = this.formatFeedbackWithBullets(feedback);
      this.modalRef = this.modalService.open(this.myModal, {
        size: 'lg',
        modalDialogClass: 'mymodal',
        centered: true,
        backdrop: 'static',
        animation: true,
        keyboard: false,
        backdropClass: 'modal-backdrop',
        windowClass: 'custom-overlay-container',
      });
    } catch (error) {
      // console.log(error);
    }
  }
  /**
   * Formats the feedback text by adding bullet points to each line.
   * It ensures that the first line is not prefixed with a bullet point,
   * and subsequent lines are prefixed with a bullet point if they are not already.
   * @param rawFeedback The raw feedback text to be formatted.
   * @returns The formatted feedback text with bullet points.
   */
  formatFeedbackWithBullets(rawFeedback: string): string {
    const lines = rawFeedback.split('\n');
    return lines
      .map((line, index) => {
        const trimmed = line.trim();

        if (index !== 0 && trimmed && !trimmed.startsWith('•')) {
          return `• ${trimmed.replace(/^[-*]\s*/, '')}`;
        }
        return trimmed;
      })
      .join('\n');
  }

  //Handles changes to the selected school calendar by subscribing to updates from local storage.
  async handleCalendarChangeData(): Promise<void> {
    this.storageService.setSelectedSchoolsCalendarToLocalStorage
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (res) => {
        if (res) {
          // Waits for 2 second before proceeding to allow any changes to be fully applied.
          // This delay ensures that the calendar and default classroom are properly set before fetching new data.
          setTimeout(async () => {
            this.spinner.show();
            this.getRecordsAsPerSelectedTab();
            this.spinner.hide();
          }, 2000);
        }
      });
  }
}
